<script>
export default {
  name: "DidoDownloadButtonRef",
};
</script>

<script setup>
import { computed } from "vue";

// define Props
const props = defineProps({
  refOrNomenc: { type: Object, required: true },
});

// computed data for title
const title = computed(() =>
  props.refOrNomenc ? props.refOrNomenc.title : null,
);
// Computed data for tooltip
const tooltip = computed(() => {
  return props.refOrNomenc ? `Télécharger le fichier '${title.value}'` : null;
});
// computed data for link
const link = computed(() => (props.refOrNomenc ? props.refOrNomenc.url : null));
</script>

<template>
  <div v-if="props.refOrNomenc">
    <QBtnGroup unelevated class="no-border-radius">
      <QBtn
        :href="link"
        target="_blank"
        color="secondary"
        dense
        icon="mdi-download"
        label="télécharger le fichier"
        :title="tooltip"
        no-caps
        size="sm"
        class="q-pr-xs"
      />
    </QBtnGroup>
  </div>
</template>
